import { render } from "./DropdownLabel.vue?vue&type=template&id=97524ca8&scoped=true"
import script from "./DropdownLabel.vue?vue&type=script&lang=js"
export * from "./DropdownLabel.vue?vue&type=script&lang=js"

import "./DropdownLabel.vue?vue&type=style&index=0&id=97524ca8&scoped=true&lang=css"
import "./DropdownLabel.vue?vue&type=style&index=1&id=97524ca8&lang=css"

import exportComponent from "C:\\projects\\epd-cnmp-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97524ca8"]])

export default __exports__